import React from 'react'
import { useTranslation } from 'react-i18next'
import { PageHead } from '@fs/zion-head'
import NoLandingPageFound from './NoLandingPageFound'
import { placeholderSeafoamJpg } from '../../images'
import PageContent from './content/PageContent'
import { PageLead } from './lead/PageLead'
import { getBrowserSeoLocales } from '../helpers'

const defaultImage = { url: placeholderSeafoamJpg, width: 1200, height: 630 }

/** @deprecated - see SeoPageHead */
export const HtmlPageHead = ({ name, description, alternateLocales, image }) => {
  const [t] = useTranslation()
  return (
    <PageHead
      title={name}
      description={description}
      // this will allow partial overrides of the default image
      image={{ ...defaultImage, ...image }}
      siteName={t('global.rootstech', 'RootsTech')}
      type="website"
      twitterSite="@RootsTechConf"
      includeHreflang
      hreflangConfig={{ languages: getBrowserSeoLocales(alternateLocales) }}
    />
  )
}

export default function GenericPage({ loading, data, flavor, rootPath }) {
  return (
    <>
      {!loading && !data && <NoLandingPageFound rootPath={rootPath} flavor={flavor} />}
      {!loading && data && (
        <>
          <HtmlPageHead name={data.name} description={data.description} alternateLocales={data.alternateLocales} />
          <PageLead data={data} flavor={flavor} />
          <PageContent content={data.content} flavor={flavor} />
        </>
      )}
    </>
  )
}
